import { useEffect, useState } from 'react';
import useEftposAccount from '../../../Hooks/UseEftposAccount';
import LoadingPanel from '../../../Abstracts/Components/LoadingPanel';
import useUserApi, { ErrorHandler } from '../../../Services/UserApi';
import EditDepositAccountForm, { EditableEftposDepositAccount } from './EditDepositAccountForm';
import { useHistory } from 'react-router-dom';
import { BackButton } from '../BreadCrumbs';
import useQuery from '../../../Hooks/UseQuery';

export default function RegisterDepositAccount() {
	const { eftposAccount } = useEftposAccount();
	const [depositAccount, setDepositAccount] = useState<EditableEftposDepositAccount>();

	const query = useQuery();
	const context = query.get('context');
	const bookingId = query.get('bookingId');

	let backLocation = '/deposit-accounts';
	switch (context) {
		case 'dashboard':
			backLocation = '/';
			break;
		case 'bookings':
			backLocation = `/bookings`;
			break;
		case 'deposit-accounts':
			backLocation = `/deposit-accounts`;
			break;
	}

	useEffect(() => {
		if (!eftposAccount) {
			return;
		}
		setDepositAccount({
			EftposDepositAccountId: 0,
			EftposDepositAccountEftposAccountId: eftposAccount.EftposAccountId,
			EftposDepositAccountName: '',
			EftposDepositAccountAccount: '',
			EftposDepositAccountBsb: '',
		});
	}, [eftposAccount]);

	const userApi = useUserApi();
	const history = useHistory();

	const saveMenu = (depositAccount: EditableEftposDepositAccount) => {
		return userApi({
			route: 'eftpos/api',
			data: {
				action: 'createEftposDepositAccount',
				eftposDepositAccount: depositAccount,
				bookingId,
			},
			errorMessage: 'Error saving deposit account',
		})
			.then(() => history.push(backLocation))
			.catch((e: unknown) => ErrorHandler.toast(e));
	};

	if (!eftposAccount || !depositAccount) {
		return <LoadingPanel />;
	}

	return (
		<>
			<BackButton text="Back" to={backLocation} />
			<EditDepositAccountForm
				depositAccount={depositAccount}
				setDepositAccount={setDepositAccount}
				onSave={saveMenu}
				saveButtonText="Register deposit account"
			/>
		</>
	);
}
